module.exports = __webpack_public_path__ + "media/images/testimonials/logo-telenor-8e3447092d6dfd93531f84c082dbaa36.svg";